import React from "react";
import { Box, Button, Checkbox, Typography } from "@mui/material";

const WEEKDAYS = [
  { id: 1, label: "Mo" },
  { id: 2, label: "Di" },
  { id: 3, label: "Mi" },
  { id: 4, label: "Do" },
  { id: 5, label: "Fr" },
];

const TIMESLOTS = [
  { id: 1, label: "07:30" },
  { id: 2, label: "08:25" },
  { id: 3, label: "10:55" },
  { id: 4, label: "11:40" },
  { id: 5, label: "12:20" },
  { id: 6, label: "13:10" },
  { id: 7, label: "13:55" },
  { id: 8, label: "14:40" },
  { id: 9, label: "15:25" },
];

export default function BSZRoomAvailability({ availability = [], onChange }) {
  const isChecked = (weekday, timeslotId) =>
    availability.some(
      (a) => a.weekday === weekday && a.timeslotId === timeslotId,
    );

  const toggleAvailability = (weekday, timeslotId) => {
    const exists = availability.some(
      (a) => a.weekday === weekday && a.timeslotId === timeslotId,
    );

    if (exists) {
      onChange(
        availability.filter(
          (a) => !(a.weekday === weekday && a.timeslotId === timeslotId),
        ),
      );

      return;
    }

    onChange([
      ...availability,
      {
        weekday,
        timeslotId,
      },
    ]);
  };

  const selectAll = () => {
    const all = [];

    WEEKDAYS.forEach((day) => {
      TIMESLOTS.forEach((slot) => {
        all.push({
          weekday: day.id,
          timeslotId: slot.id,
        });
      });
    });

    onChange(all);
  };

  const clearAll = () => {
    onChange([]);
  };

  return (
    <Box mt={4}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="subtitle1">Verfügbarkeit</Typography>

        <Typography variant="caption" sx={{ opacity: 0.7 }}>
          {availability.length} von 20 Zeitfenstern ausgewählt
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          mb: 2,
        }}
      >
        <Button size="small" variant="outlined" onClick={selectAll}>
          Alle
        </Button>

        <Button size="small" variant="outlined" onClick={clearAll}>
          Keine
        </Button>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `80px repeat(${TIMESLOTS.length}, 1fr)`,
          gap: 1,
          alignItems: "center",
        }}
      >
        <Box />

        {TIMESLOTS.map((slot) => (
          <Typography
            key={slot.id}
            align="center"
            variant="caption"
            sx={{
              fontWeight: 700,
              opacity: 0.8,
            }}
          >
            {slot.label}
          </Typography>
        ))}

        {WEEKDAYS.map((day) => (
          <React.Fragment key={day.id}>
            <Typography sx={{ fontWeight: 600 }}>{day.label}</Typography>

            {TIMESLOTS.map((slot) => (
              <Box
                key={`${day.id}-${slot.id}`}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Checkbox
                  checked={isChecked(day.id, slot.id)}
                  onChange={() => toggleAvailability(day.id, slot.id)}
                />
              </Box>
            ))}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}
